import axios, { AxiosResponse, CancelToken } from "axios";
import { GetUnifiedLogsRequest, LogEventResponse } from "../../models/LogEvents";
import { GetConferenceTrackingRecordsResponse } from "../../models/TwilioModels";

export const getTwilioCallDetailsPage =
	(request: GetUnifiedLogsRequest, productId: string, subscriptionId: string, accountSid: string, callSids: string) =>
	async (cancelToken?: CancelToken): Promise<AxiosResponse<LogEventResponse>> => {
		return await axios.post(
			`/api/v1/${productId}/Twilio/${subscriptionId}/${accountSid}/CallDetails?callSids=${callSids}`,
			request,
			{
				cancelToken: cancelToken,
			},
		);
	};

export const getTwilioChatDetailsPage =
	(request: GetUnifiedLogsRequest, productId: string, subscriptionId: string, accountSid: string, channelSid: string) =>
	async (cancelToken?: CancelToken): Promise<AxiosResponse<LogEventResponse>> => {
		const data = await axios.post(
			`/api/v1/${productId}/Twilio/${subscriptionId}/${accountSid}/ChannelDetails/${channelSid}`,
			request,
			{
				cancelToken: cancelToken,
			},
		);
		return data;
	};

export const getTwilioConferenceTrackingRecords =
	(productId: string, subscriptionId: string, accountSid: string, callSid: string) =>
	async (cancelToken?: CancelToken): Promise<AxiosResponse<GetConferenceTrackingRecordsResponse[]>> => {
		return await axios.get(`/api/v1/${productId}/Twilio/${subscriptionId}/${accountSid}/conferencerecords/${callSid}`, {
			cancelToken: cancelToken,
		});
	};
